import { render, staticRenderFns } from "./audit-trail.vue?vue&type=template&id=60ddc262&scoped=true"
import script from "./audit-trail.vue?vue&type=script&lang=js"
export * from "./audit-trail.vue?vue&type=script&lang=js"
import style0 from "./audit-trail.vue?vue&type=style&index=0&id=60ddc262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddc262",
  null
  
)

export default component.exports